import { render, staticRenderFns } from "./ServiceDialog.vue?vue&type=template&id=efd5d316&scoped=true"
import script from "./ServiceDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./ServiceDialog.vue?vue&type=style&index=0&id=efd5d316&prod&lang=css"
import style1 from "./ServiceDialog.vue?vue&type=style&index=1&id=efd5d316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd5d316",
  null
  
)

export default component.exports